/* eslint-disable import/prefer-default-export */
// @flow
/* -----------------Types--------------- */
import {
  type FolderTypes,
  folderType,
} from '../types';

const getSmartFolderTitle = (smartFolderType: FolderTypes) => {
  const titleMap = {
    [folderType.Favorites]: 'Favorites',
    [folderType.Recent]: 'Recently studied',
    [folderType.Tasks]: 'Today\'s Tasks',
    [folderType.Shared]: 'Shared with me',
    [folderType.Created]: 'Created by me',
    [folderType.Folder]: 'Folder',
    [folderType.StudyPacks]: 'Study-Packs',
    [folderType.Schedule]: 'Schedule',
    [folderType.Search]: 'Search',
  };

  return titleMap[smartFolderType];
};

export {
  getSmartFolderTitle,
};
